import { EventDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import EventDrillDownTableRow from '../EventDrillDownTableRow/EventDrillDownTableRow';

type EventDrillDownTableBodyProps = {
  events: Array<EventDrillDownItem>;
};

const EventDrillDownTableBody: React.FC<EventDrillDownTableBodyProps> = ({
  events,
}) => {
  return (
    <tbody>
      {events.map((event) => (
        <EventDrillDownTableRow key={event.id} event={event} />
      ))}
    </tbody>
  );
};

export default EventDrillDownTableBody;
